import { useState } from 'react';
import Button from 'components/new-ui/base/button/Button';
import { Declaration } from 'store/declarations/declaration';
import { canEnsBeConsulted } from 'views/declarations/utils/declaration-utils';
import { StyledButton } from 'views/declarations/declaration-tabs/declaration-form/Form.styles';
import { FooterButton } from 'views/declarations/declaration-tabs/view-only/FormViewOnly';
import ConsultEnsModal from './ConsultEnsModal';

type Props = {
    declaration?: Declaration;
    newUi?: boolean;
    /**
     * Renders the button for the ENS listing, where there is no declaration to consult against — the
     * ENS is identified inside the modal instead, so none of the declaration conditions apply.
     */
    standalone?: boolean;
};

const ConsultEnsModalButton = ({ declaration, newUi, standalone = false }: Props) => {
    const [consultModalOpen, setConsultModalOpen] = useState<boolean>(false);

    const showConsultButton =
        standalone || (Boolean(declaration?.ics2ENSDeclaration) && canEnsBeConsulted(declaration?.status));

    if (!showConsultButton) return null;

    const openModal = () => setConsultModalOpen(true);

    return (
        <>
            {standalone ? (
                <Button onClick={openModal}>Consult ENS</Button>
            ) : newUi ? (
                <StyledButton onClick={openModal}>Consult ENS</StyledButton>
            ) : (
                <FooterButton onClick={openModal}>Consult ENS</FooterButton>
            )}

            <ConsultEnsModal
                visible={consultModalOpen}
                declaration={declaration}
                standalone={standalone}
                onCancel={() => setConsultModalOpen(false)}
            />
        </>
    );
};

export default ConsultEnsModalButton;
